const UserInfo = () => import('Views/userInfo/user-info');
const JoinList = () => import('Views/userInfo/join-list');
const JoinDetail = () => import('Views/userInfo/join-detail');

export default[
  { path: '/user-info', component: UserInfo },
  { path: '/user-info/:facultyId/:courseId/:enrollmentId', component: UserInfo },
  { path: '/join-list', component: JoinList },
  { path: '/join-detail/:id', component: JoinDetail },
];



// WEBPACK FOOTER //
// ./src/router/userInfo.js